import React from 'react';
import { cn } from '@/lib/utils';

interface AvatarProps {
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Avatar: React.FC<AvatarProps> = ({ 
  children, 
  className,
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6 text-xs',
    md: 'h-8 w-8 text-sm',
    lg: 'h-10 w-10 text-base',
    xl: 'h-12 w-12 text-lg',
  };

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-muted text-foreground font-medium',
        sizeClasses[size],
        className
      )}
    >
      {children}
    </div>
  );
};
